import { postApiRequest } from "utils/fetch-helper";

export async function sendBookingNotification(bookingId: string, client_id: string) {
    const body = {}
    const headers = {}
    const expects_nothing = true

    return await postApiRequest(
        `/v1/notification/send-booking-notification?bookingId=${bookingId}&clientId=${client_id}`,
        body,
        headers,
        expects_nothing
    )
}